// -----------------------------------------------------------------------------
// Home
// -----------------------------------------------------------------------------

import swal from '../../../js/sweetalert.min.js'; // eslint-disable-line new-cap

const init = () => {
  if ($('.js-eqf-favorites').length <= 0) {
    return;
  }

  initEventListeners();
};

/**
 * AJAX einrichten
 */
const initEventListeners = () => {
  const vars = JSON.parse(document.querySelector('.js-eqf-favorites #vars').textContent);
  const trans = JSON.parse(document.querySelector('.js-eqf-favorites #trans').textContent);

  // -----------------------------------------------------------------------------
  // Nachricht senden
  // -----------------------------------------------------------------------------

  $('.writeMsg').click(function (e) {
    e.preventDefault();
    var userId = $(this).attr('data-userid');
    swal({ // eslint-disable-line new-cap
      title: trans.ihre_nachricht,
      content: 'input',
      showCancelButton: true,
      buttons: [trans.abbrechen, trans.nachricht_absenden]
    }).then(function (result) {
      if (result) {
        $.ajax({
          url: vars.LNKsendmsg,
          method: 'POST',
          data: {
            id: userId,
            text: result,
            CSRF_token: $('.js-csrf-token-writeMsg').val()
          }
        })
          .done(function () {
            swal('', trans.ihre_nachricht_an_x_wurde_uebermittelt, 'success'); // eslint-disable-line new-cap
          })
          .fail(function () {
            swal('', trans.ihre_nachricht_konnte_nicht_zugestellt_werden, 'error'); // eslint-disable-line new-cap
          });
      }
    });
  });
};

export {
  init
};
